import { render, staticRenderFns } from "./CardInfoUser.vue?vue&type=template&id=637b38a3"
import script from "./CardInfoUser.vue?vue&type=script&lang=js"
export * from "./CardInfoUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports